import './assets/css/App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import {} from 'react-router-dom';
import AuthLayout from './layouts/auth';
import AdminLayout from './layouts/admin';
import RTLLayout from './layouts/rtl';
import {
  ChakraProvider,
  // extendTheme
} from '@chakra-ui/react';
import initialTheme from './theme/theme'; //  { themeGreen }
import { useState } from 'react';
import { useAuth } from 'contexts/AuthContext';
// Chakra imports

export default function Main() {
  // eslint-disable-next-line
  const [currentTheme, setCurrentTheme] = useState(initialTheme);
  const {auth} = useAuth()

  return (
    <ChakraProvider theme={currentTheme}>
      <Routes>
        { !!auth ? (
            <>
              <Route path="admin/*" element={<AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />} />
              <Route path="*" element={<Navigate to='admin/dashboards/default' />} />
            </>
          ) : (
            <>
              <Route path="auth/*" element={<AuthLayout />} />
              <Route path="*" element={<Navigate to='/auth/sign-in' />} />
            </>
          )
        }
      </Routes>
    </ChakraProvider>
  );
}
